import confetti from "canvas-confetti";
import { toast } from "sonner";
import { api } from "@/lib/api";

const KEY = "snaplist.listingGoalCelebrated";
const localDay = () => new Date().toLocaleDateString("en-CA");

export function burst() {
  const base = { zIndex: 9999, particleCount: 90, spread: 75 };
  confetti({ ...base, angle: 60, origin: { x: 0.1, y: 0.6 } });
  confetti({ ...base, angle: 120, origin: { x: 0.9, y: 0.6 } });
  setTimeout(() => confetti({ zIndex: 9999, particleCount: 110, spread: 110, startVelocity: 35, origin: { y: 0.35 } }), 220);
}

// Once per weekend per goal, only while that weekend is still in progress.
export function celebrateWeekendGoal(weekend, goal, live) {
  if (!live || !goal || weekend.revenue < goal) return;
  const key = "snaplist.weekendGoalCelebrated";
  const mark = `${weekend.start}:${goal}`;
  if (localStorage.getItem(key) === mark) return;
  localStorage.setItem(key, mark);
  burst();
  toast.success(`Weekend goal smashed! $${Math.round(weekend.revenue).toLocaleString()} in sales this weekend.`, { duration: 6000 });
}

function celebrateMonth(m) {
  if (!m?.goal || m.count < m.goal) return false;
  const key = "snaplist.monthlyGoalCelebrated";
  const mark = `${localDay().slice(0, 7)}:${m.goal}`;
  if (localStorage.getItem(key) === mark) return false;
  localStorage.setItem(key, mark);
  toast.success(`Monthly goal crushed! ${m.count} listing${m.count === 1 ? "" : "s"} this month.`, { duration: 7000 });
  return true;
}

export function celebrateIfGoalHit(data) {
  if (celebrateMonth(data?.month)) burst();
  if (!data?.goal || data.today < data.goal) return;
  const mark = `${localDay()}:${data.goal}`;
  if (localStorage.getItem(KEY) === mark) return;
  localStorage.setItem(KEY, mark);
  burst();
  const streak = data.streak > 1 ? ` That's a ${data.streak}-day streak!` : "";
  toast.success(`Daily goal hit! ${data.today} listing${data.today === 1 ? "" : "s"} today.${streak}`, { duration: 6000 });
}

// Call after a successful push to eBay.
export function checkListingGoal() {
  api.get("/stats/listing-goal", { params: { tz_offset: new Date().getTimezoneOffset() } })
    .then((r) => celebrateIfGoalHit(r.data)).catch(() => {});
}
